// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import { WorkbookVariantFragmentFragmentDoc } from "../../Workbook/gql/Fragment.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type WorkbookVariantQueryVariables = Types.Exact<{
  variantId: Types.Scalars["ID"]["input"];
}>;

export type WorkbookVariantQuery = {
  __typename?: "GraphqlQuery";
  getWorkbookVariant: {
    __typename?: "WorkbookVariant";
    id: string;
    createdAt: number;
    updatedAt: number;
    description?: string | null;
    queryFingerprint: string;
    queryText: string;
    name: string;
    queryTextWithAlias: string;
    paramRefAliasMap: any;
    draft: boolean;
    plannerSettings: any;
    appliedInsights?: any | null;
    workbookResults: Array<{
      __typename?: "WorkbookResult";
      id: string;
      format: string;
      resultSource: string;
      createdAt: number;
      updatedAt: number;
      status?: string | null;
      errorMessage?: string | null;
      totalCost?: number | null;
      totalSharedBlksHit?: number | null;
      totalSharedBlksRead?: number | null;
      totalSharedBlksWritten?: number | null;
      totalSharedBlksDirtied?: number | null;
      totalBlkReadTime?: number | null;
      totalBlkWriteTime?: number | null;
      planNodeTypes?: Array<string | null> | null;
      runtimeMs?: number | null;
      planFingerprint?: string | null;
      parameterSetId?: string | null;
      nodeInsights?: any | null;
      user?: {
        __typename?: "User";
        id: string;
        fullname?: string | null;
      } | null;
    }>;
    user?: { __typename?: "User"; id: string; fullname?: string | null } | null;
    queryTextWithParameters: Array<{
      __typename?: "QueryTextWithParameters";
      id: string;
      parameterSetId: string;
      queryWithParameters: string;
    }>;
  };
};

export const WorkbookVariantDocument = gql`
  query WorkbookVariant($variantId: ID!) {
    getWorkbookVariant(variantId: $variantId) {
      ...WorkbookVariantFragment
    }
  }
  ${WorkbookVariantFragmentFragmentDoc}
`;

/**
 * __useWorkbookVariantQuery__
 *
 * To run a query within a React component, call `useWorkbookVariantQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbookVariantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbookVariantQuery({
 *   variables: {
 *      variantId: // value for 'variantId'
 *   },
 * });
 */
export function useWorkbookVariantQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkbookVariantQuery,
    WorkbookVariantQueryVariables
  > &
    (
      | { variables: WorkbookVariantQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkbookVariantQuery, WorkbookVariantQueryVariables>(
    WorkbookVariantDocument,
    options,
  );
}
export function useWorkbookVariantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkbookVariantQuery,
    WorkbookVariantQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkbookVariantQuery,
    WorkbookVariantQueryVariables
  >(WorkbookVariantDocument, options);
}
// @ts-ignore
export function useWorkbookVariantSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkbookVariantQuery,
    WorkbookVariantQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkbookVariantQuery,
  WorkbookVariantQueryVariables
>;
export function useWorkbookVariantSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkbookVariantQuery,
        WorkbookVariantQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkbookVariantQuery | undefined,
  WorkbookVariantQueryVariables
>;
export function useWorkbookVariantSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkbookVariantQuery,
        WorkbookVariantQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkbookVariantQuery,
    WorkbookVariantQueryVariables
  >(WorkbookVariantDocument, options);
}
export type WorkbookVariantQueryHookResult = ReturnType<
  typeof useWorkbookVariantQuery
>;
export type WorkbookVariantLazyQueryHookResult = ReturnType<
  typeof useWorkbookVariantLazyQuery
>;
export type WorkbookVariantSuspenseQueryHookResult = ReturnType<
  typeof useWorkbookVariantSuspenseQuery
>;
export type WorkbookVariantQueryResult = Apollo.QueryResult<
  WorkbookVariantQuery,
  WorkbookVariantQueryVariables
>;
